<div [ngClass]="{'layout-static-inactive layout-mobile-active': !showMenu}"
     class="layout-wrapper layout-topbar-light layout-static layout-menu-light">

  <app-topbar (openCloseMenu)="switchMenu()"></app-topbar>
  <p-toast></p-toast>
  <p-confirmDialog [breakpoints]="{'960px': '175vw', '640px': '200vw'}" [style]="{width: '50vw'}">
    Content
  </p-confirmDialog>
  <app-menu [showMenu]="showMenu"></app-menu>

  <div class="layout-main">
    <div class="layout-content" style="min-height:300px">
      <router-outlet></router-outlet>
    </div>
  </div>

</div>

<script src="app.js" type="module"></script>
